import { Flow, FlowList } from 'src/utils/redux/flow';
import reducerFactory from './reducer';
import sagasFactory from './sagas';

export const flows = new FlowList(
  new Flow('get', []),
);

export const service = flows;
export const reducer = reducerFactory(flows);
export const sagas = sagasFactory(flows);

export default {
  flows,
  service,
  reducer,
  sagas,
};
